import axios from "axios";
import { BASE_URL } from "../constants/api";
import { createStandaloneToast } from '@chakra-ui/toast'
import { CONTENT_TYPE } from "../constants";
import { isUnauthorized } from "../helpers/apiHelper";
import { getServerError } from "../helpers/errorHandler";
const { toast } = createStandaloneToast()

async function Get({ path, token, toastMessage, toastError, contentType = CONTENT_TYPE.JSON }) {
  try {
    let url = BASE_URL + path;
    const headers = { "Content-Type": contentType }
    if (token) {
      headers.Authorization = `Bearer ${token}`
    }
    const response = await axios.get(url, { headers });

    if (toastMessage) {
      let message = response.data?.apiMessage || "Success!"
      toast({
        title: 'Congrats!',
        description: message,
        status: 'success',
        id: message,
        isClosable: true,
        position: "top",
        variant: "subtle"
      })
    }
    return response.data;
  } catch (error) {

    if (isUnauthorized(error)) {
      localStorage.clear();
      window.location.reload();
      return;
    }

    if (toastError) {
      const message = getServerError(error)
      toast({
        title: 'Error!',
        description: message,
        status: 'error',
        isClosable: true,
        position: "top",
        variant: "subtle"
      })
    }
    console.error("Error in Get.js: ", error)
  }
}

export { Get };